import { render } from "./ModalUi.vue?vue&type=template&id=2056721a&scoped=true&ts=true"
import script from "./ModalUi.vue?vue&type=script&lang=ts"
export * from "./ModalUi.vue?vue&type=script&lang=ts"

import "./ModalUi.vue?vue&type=style&index=0&id=2056721a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2056721a"]])

export default __exports__